/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordPresenceActivity
 */
export interface DiscordPresenceActivity {
    /**
     * The game name reported by Discord Rich Presence.
     * @type {string}
     * @memberof DiscordPresenceActivity
     */
    name: string;
    /**
     * Discord activity platform ("xbox" | "ps4" | "ps5" | "playstation").
     * @type {string}
     * @memberof DiscordPresenceActivity
     */
    platform: string;
    /**
     * Discord detectable-games application id — the ID join key to our game catalog.
     * @type {string}
     * @memberof DiscordPresenceActivity
     */
    applicationId?: string;
    /**
     * Discord activity timestamps.start — when this console session began.
     * @type {number}
     * @memberof DiscordPresenceActivity
     */
    startMs?: number;
    /**
     * Rich-presence "details" line, when the title exposes it.
     * @type {string}
     * @memberof DiscordPresenceActivity
     */
    details?: string;
    /**
     * Rich-presence "state" line, when the title exposes it.
     * @type {string}
     * @memberof DiscordPresenceActivity
     */
    state?: string;
    /**
     * [current, max] party size from rich presence, when present.
     * @type {Array<number>}
     * @memberof DiscordPresenceActivity
     */
    partySize?: Array<number>;
}

/**
 * Check if a given object implements the DiscordPresenceActivity interface.
 */
export function instanceOfDiscordPresenceActivity(value: object): value is DiscordPresenceActivity {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function DiscordPresenceActivityFromJSON(json: any): DiscordPresenceActivity {
    return DiscordPresenceActivityFromJSONTyped(json, false);
}

export function DiscordPresenceActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordPresenceActivity {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'platform': json['platform'],
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
        'startMs': json['startMs'] == null ? undefined : json['startMs'],
        'details': json['details'] == null ? undefined : json['details'],
        'state': json['state'] == null ? undefined : json['state'],
        'partySize': json['partySize'] == null ? undefined : json['partySize'],
    };
}

export function DiscordPresenceActivityToJSON(json: any): DiscordPresenceActivity {
    return DiscordPresenceActivityToJSONTyped(json, false);
}

export function DiscordPresenceActivityToJSONTyped(value?: DiscordPresenceActivity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'platform': value['platform'],
        'applicationId': value['applicationId'],
        'startMs': value['startMs'],
        'details': value['details'],
        'state': value['state'],
        'partySize': value['partySize'],
    };
}

